import { DatePicker, Input, PolicyDispatchingPermission, Select, assets } from '@pulseops/common'
import React from 'react'
import { Controller } from 'react-hook-form'
import { Text, View } from 'react-native'
import {
  borderedDatePickerContainerStyle,
  borderedInputStyle,
  borderedSelectStyle
} from '../styles/policyDispatchingStyles'
import { getPermissions } from '../utils/policyDispatchingUtils'

const statusOptions = [
  { value: '', label: 'Tất cả' },
  { value: 'AVAILABLE', label: 'Còn trong kho' },
  { value: 'ISSUED', label: 'Nhận từ NB' },
  { value: 'IN_USED', label: 'Đã giao' },
  { value: 'RETURNED', label: 'Đã trả lại' }
]

export default function PDStockInFilter({
  control,
  onSearch,
  totalCount = 0,
  selectedCount = 0,
  onStockIn = () => {},
  onGiveBack = () => {},
  onChangeStockInDate = () => {},
  onChangeOffice = () => {},
  onDownload = () => {}
}: {
  control: any
  onSearch: () => void
  totalCount?: number
  selectedCount?: number
  onStockIn?: () => void
  onGiveBack?: () => void
  onChangeStockInDate?: () => void
  onChangeOffice?: () => void
  onDownload?: () => void
}) {
  const permissions = getPermissions()
  const allowImport = permissions.includes(PolicyDispatchingPermission.StockInImport) && selectedCount > 0
  const allowGiveBack = permissions.includes(PolicyDispatchingPermission.StockInReturn) && selectedCount > 0
  const allowChangeDate = permissions.includes(PolicyDispatchingPermission.StockInChangeImportDate) && selectedCount > 0
  const allowChangeOffice = permissions.includes(PolicyDispatchingPermission.StockInChangeOffice) && selectedCount > 0
  const allowDownload = permissions.includes(PolicyDispatchingPermission.StockInDownload) && totalCount > 0

  return (
    <>
      <View style={styles.inputWrapper}>
        <View style={styles.input}>
          <Controller
            control={control}
            name={'issueDate'}
            rules={{
              required: {
                value: true,
                message: 'Ngày phát hành là bắt buộc'
              },
              validate: (value: Date | null) => {
                if (!value) return true
                const today = new Date()
                today.setHours(23, 59, 59, 999)
                return value.getTime() <= today.getTime() || 'Ngày phát hành không được lớn hơn ngày hiện tại'
              }
            }}
            render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
              <DatePicker
                label={'Ngày phát hành'}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                maxDate={undefined}
                minDate={undefined}
                minDateMessage={''}
                errorMessage={error?.message}
                hideUnderline
                containerStyle={borderedDatePickerContainerStyle}
                required
              />
            )}
          />
        </View>
        <View style={styles.input}>
          <Controller
            name="contractNumber"
            control={control}
            render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
              <Input
                title={'Số hợp đồng'}
                placeholder="Phân cách nhiều số hợp đồng bằng dấu phẩy"
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                errorMessage={error?.message}
                inputStyle={borderedInputStyle}
                filled
                maxLength={1000}
              />
            )}
          />
        </View>
        <View style={styles.input}>
          <Controller
            name="status"
            control={control}
            render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
              <Select
                label={'Tình trạng'}
                options={statusOptions}
                placeholder={'Chọn tình trạng'}
                onChange={(e) => {
                  onChange(e)
                }}
                onBlur={onBlur}
                value={value}
                key={value?.value}
                errorMessage={error?.message}
                containerStyles={borderedSelectStyle}
                filled
              />
            )}
          />
        </View>

        <View style={styles.input}>
          <Controller
            name="remark"
            control={control}
            render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
              <Input
                title={'Ghi chú'}
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                errorMessage={error?.message}
                inputStyle={borderedInputStyle}
                filled
                maxLength={1000}
              />
            )}
          />
        </View>
        <View style={styles.input}>
          <Controller
            control={control}
            name={'stockInDate'}
            render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
              <DatePicker
                alwaysShow
                label={'Ngày nhập kho'}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                maxDate={new Date()}
                minDate={undefined}
                minDateMessage={''}
                errorMessage={error?.message}
                hideUnderline
                containerStyle={borderedDatePickerContainerStyle}
                inputStyle={{ paddingBottom: 3 }}
              />
            )}
          />
        </View>
        <View style={styles.input}>
          <Controller
            name="agentNumber"
            control={control}
            render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
              <Input
                title={'Mã số đại lý'}
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                errorMessage={error?.message}
                inputStyle={borderedInputStyle}
                filled
                maxLength={8}
              />
            )}
          />
        </View>

        <View
          style={
            {
              width: '100%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              gap: 10,
              marginTop: 20
            } as any
          }
        >
          <button style={styles.submitButton} type="button" onClick={onSearch}>
            <span style={styles.mr_5}>
              <assets.SearchWhite />
            </span>
            Tìm
          </button>
        </View>
      </View>
      <View
        style={
          {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            marginTop: 30,
            justifyContent: 'space-between'
          } as any
        }
      >
        <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 5 } as any}>
          <button
            style={!allowImport ? styles.disabledButton : styles.submitButton}
            disabled={!allowImport}
            onClick={onStockIn}
          >
            <span style={styles.mr_5}>
              <assets.PDEntry />
            </span>
            Nhập kho
          </button>
          <button
            style={!allowGiveBack ? styles.disabledButton : styles.button}
            disabled={!allowGiveBack}
            onClick={onGiveBack}
          >
            <span style={styles.mr_5}>
              <assets.PDReturn />
            </span>
            Trả lại
          </button>
          <button
            style={!allowChangeDate ? styles.disabledButton : styles.button}
            disabled={!allowChangeDate}
            onClick={onChangeStockInDate}
          >
            <span style={styles.mr_5}>
              <assets.PDEntryDate />
            </span>
            Đổi ngày nhập kho
          </button>
          <button
            style={!allowChangeOffice ? styles.disabledButton : styles.button}
            disabled={!allowChangeOffice}
            onClick={onChangeOffice}
          >
            <span style={styles.mr_5}>
              <assets.PDOffice />
            </span>
            Đổi văn phòng
          </button>
          <button
            style={!allowDownload ? styles.disabledButton : styles.button}
            disabled={!allowDownload}
            onClick={onDownload}
          >
            <span style={styles.mr_5}>
              <assets.PDDownload />
            </span>
            Tải về
          </button>
        </View>
        <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 5 } as any}>
          <View
            style={
              {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                paddingTop: 8,
                paddingRight: 10,
                paddingBottom: 8,
                paddingLeft: 10,
                borderRadius: '999px',
                backgroundColor: '#fff',
                whiteSpace: 'nowrap'
              } as any
            }
          >
            <Text>
              Tổng số: <span style={{ fontWeight: 'bold' }}>{totalCount}</span>
            </Text>
          </View>
          <View
            style={
              {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                paddingTop: 8,
                paddingRight: 10,
                paddingBottom: 8,
                paddingLeft: 10,
                borderRadius: '999px',
                backgroundColor: '#fff',
                whiteSpace: 'nowrap'
              } as any
            }
          >
            <Text>
              Đã chọn: <span style={{ fontWeight: 'bold' }}>{selectedCount}</span>
            </Text>
          </View>
        </View>
      </View>
    </>
  )
}

const styles: Record<string, any> = {
  inputWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap' as const,
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '16px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    gap: '20px'
  },
  input: {
    width: 'calc((100% - 40px)/3)'
  },
  submitButton: {
    backgroundColor: '#ED1B2E',
    color: '#fff',
    borderWidth: 0,
    paddingTop: 8,
    paddingRight: 16,
    paddingBottom: 8,
    paddingLeft: 16,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 12,
    fontWeight: '600'
  },
  mr_5: {
    marginRight: '5px'
  },
  button: {
    backgroundColor: '#fff',
    color: '#000',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#d1d5dc',
    paddingTop: 8,
    paddingRight: 16,
    paddingBottom: 8,
    paddingLeft: 16,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 12,
    fontWeight: '600'
  },
  disabledButton: {
    backgroundColor: '#e5e7eb',
    color: '#9ca3af',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#d1d5db',
    paddingTop: 8,
    paddingRight: 16,
    paddingBottom: 8,
    paddingLeft: 16,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 12,
    fontWeight: '600',
    cursor: 'not-allowed',
    opacity: 0.7
  }
}
